import axios from "axios";

export const AGENT_CHAT_UPLOAD_PAYLOAD_TOO_LARGE_MESSAGE = "Payload Too Large";

const AGENT_CHAT_UPLOAD_FAILED_MESSAGE = "Upload failed";

interface AgentChatUploadErrorMessageOptions {
    directUpload?: boolean;
}

function getResponseMessage(data: unknown): string | undefined {
    if (typeof data !== "object" || data === null) {
        return undefined;
    }
    const record = data as Record<string, unknown>;
    if (typeof record.error === "string") {
        return record.error;
    }
    if (typeof record.message === "string") {
        return record.message;
    }
}

function hasPayloadTooLargeText(value: unknown): boolean {
    return (
        typeof value === "string" &&
        value.toLowerCase().includes("payload too large")
    );
}

function getRequestStatus(request: unknown): number | undefined {
    if (typeof request !== "object" || request === null) {
        return undefined;
    }

    const status = (request as Record<string, unknown>).status;
    return typeof status === "number" ? status : undefined;
}

export function getAgentChatUploadErrorMessage(
    error: unknown,
    options?: AgentChatUploadErrorMessageOptions,
): string {
    if (!axios.isAxiosError(error)) {
        return AGENT_CHAT_UPLOAD_FAILED_MESSAGE;
    }

    const status = error.response?.status ?? getRequestStatus(error.request);
    if (
        status === 413 ||
        hasPayloadTooLargeText(error.message) ||
        hasPayloadTooLargeText(error.response?.statusText)
    ) {
        return AGENT_CHAT_UPLOAD_PAYLOAD_TOO_LARGE_MESSAGE;
    }

    const apiMessage = getResponseMessage(error.response?.data);
    if (apiMessage) {
        return apiMessage;
    }

    if (!error.response && options?.directUpload) {
        return AGENT_CHAT_UPLOAD_PAYLOAD_TOO_LARGE_MESSAGE;
    }

    return AGENT_CHAT_UPLOAD_FAILED_MESSAGE;
}
